import { render, staticRenderFns } from "./ProjectTaskActivities.vue?vue&type=template&id=5534387f&scoped=true&"
import script from "./ProjectTaskActivities.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProjectTaskActivities.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5534387f",
  null
  
)

export default component.exports